module.exports = __webpack_public_path__ + "img/ICMTrader-logo.7bb7d462.svg";